export const esCafeteriaPalettes = [
  {
    palette: ["#F5EBDD", "#D6B08C", "#9A6748", "#5C3828", "#281D1A"],
    paletteName: "Café de especialidad",
    paletteDescription:
      "Cremas, caramelo y espresso para una cafetería cálida, artesanal y acogedora.",
  },
  {
    palette: ["#F7F3EA", "#D6E2D2", "#8FAF92", "#4E7257", "#263C2B"],
    paletteName: "Verde botánico",
    paletteDescription:
      "Verdes salvia y fondos claros para comunicar frescura, origen natural y calma.",
  },
  {
    palette: ["#FFF8EE", "#F3C7A5", "#E88968", "#B94E45", "#522C32"],
    paletteName: "Panadería coral",
    paletteDescription:
      "Una paleta amable y apetitosa para cafeterías con repostería, brunch o una identidad cercana.",
  },
  {
    palette: ["#F2F1ED", "#D1D5D8", "#8A9297", "#414B52", "#1E252A"],
    paletteName: "Industrial limpio",
    paletteDescription:
      "Grises y carbón para un local contemporáneo con acero, cemento, madera oscura y tipografía fuerte.",
  },
  {
    palette: ["#FFF4D6", "#F6D365", "#E9A23B", "#C95B2C", "#593326"],
    paletteName: "Sol de mañana",
    paletteDescription:
      "Amarillos y naranjas para un espacio optimista, energético y fácil de reconocer desde la calle.",
  },
  {
    palette: ["#F6F0E8", "#D8C3A5", "#A58A6A", "#765C45", "#332B29"],
    paletteName: "Tostado vintage",
    paletteDescription:
      "Tonos envejecidos y madera para una cafetería con objetos recuperados y atmósfera nostálgica.",
  },
  {
    palette: ["#F0F8F8", "#B8DDE0", "#5FA9B0", "#27727A", "#193D43"],
    paletteName: "Azul tranquilo",
    paletteDescription:
      "Azules frescos para espacios luminosos que buscan una experiencia pausada junto al café.",
  },
  {
    palette: ["#FFF7F2", "#EAC4C7", "#C98591", "#8B4D5E", "#412B3A"],
    paletteName: "Rosa editorial",
    paletteDescription:
      "Una combinación sofisticada para una cafetería de estética cuidada, creativa y fotogénica.",
  },
  {
    palette: ["#F4F1E9", "#C5C9B4", "#87916E", "#596044", "#30352B"],
    paletteName: "Oliva y cerámica",
    paletteDescription:
      "Olivas apagados y neutros para una identidad serena, artesanal y conectada con la mesa.",
  },
  {
    palette: ["#FFF8E9", "#F5B971", "#D4773C", "#9B3D32", "#3B2524"],
    paletteName: "Especias y cacao",
    paletteDescription:
      "Una paleta intensa para comunicar sabor, productos horneados y una experiencia envolvente.",
  },
];
